/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { ComponentChildren } from 'preact';
import { TrackResizeContainer } from '../PRIVATE_TrackResizeContainer';
import { horizontalScrollbarStyles } from './themes/TimeComponentStyles.css';
import type { getResolvedHorizontalScrollbarLayout } from './utils/scrollbarLayoutUtils';

type GetLayout = ReturnType<typeof getResolvedHorizontalScrollbarLayout>;
type OnRangeChange = (newMin: number, newMax: number) => void;
type Layout = ReturnType<GetLayout> & { onRangeChange: OnRangeChange } & {
  width: number;
  height: number;
};

type Props = {
  getLayout: GetLayout;
  onRangeChange: OnRangeChange;
  children: (layout: Layout) => ComponentChildren;
};

export function TimeComponentHorizontalScrollbarContainer({
  getLayout,
  onRangeChange,
  children
}: Props) {
  return (
    <div class={horizontalScrollbarStyles.base}>
      <TrackResizeContainer width="100%" height="100%">
        {(width, height) => children({ ...getLayout(width), onRangeChange, width, height })}
      </TrackResizeContainer>
    </div>
  );
}
